import styled from 'styled-components'

import { media } from '../../../utils/style-utils'

interface Props {
  rows: number
}

export const GamesLimitedGrid = styled.div.withConfig<Props>({
  shouldForwardProp: (prop: string): boolean => !prop.includes('rows'),
})`
  display: grid;
  grid-template-rows: repeat(${(props) => props.rows}, 1fr);
  grid-auto-flow: column dense;
  grid-auto-columns: 16.667%;
  overflow: hidden;

  ${media.xxl`
    grid-auto-columns: 20%;
  `}

  ${media.xs`
    grid-auto-columns: 33.334%;
  `}


  ${media.touch`
    grid-auto-columns: 32%;
    overflow: scroll;

    ${media.landscape`
      grid-auto-columns: 19.7%;
    `}
  `}
`
